<template>
  <div class="page-wrapper light">
    <router-view 
      :isLogin="isLogin"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
        isLogin: ({ user }) => user.isLogin,
    }),
  }
}

</script>
